import './PageAction.css';

import { CardBlock, Row } from '@vmware-react/clarity';
import React, { FC, useState } from 'react';

import { Link } from 'react-router-dom';
import { PageAction } from 'vrlcm-gui-types';
import { PageActionIcon } from './PageActionIcon';

interface Props {
  title?: string;
  actions: PageAction[];
  solidIconOnHover?: boolean;
  solidIcon?: boolean;
}

const PageActions: FC<Props> = props => {
  const { title, solidIconOnHover = false, solidIcon = false } = props;
  const actions = props.actions.map((action, index) => (
    <PageActionItem
      key={index}
      action={action}
      solidIconOnHover={solidIconOnHover}
      solidIcon={solidIcon}
    />
  ));

  return (
    <Row className="page-action-row">
      {title && <h2 className="page-action-row-title">{title}</h2>}
      <div className="card page-action-card">
        <CardBlock>
          <div className="page-action-items">{actions}</div>
        </CardBlock>
      </div>
    </Row>
  );
};

interface PageActionItemProps {
  action: PageAction;
  solidIconOnHover: boolean;
  solidIcon: boolean;
}

const PageActionItem: FC<PageActionItemProps> = props => {
  const { action, solidIconOnHover, solidIcon } = props;
  const [hovered, setHovered] = useState(false);

  const onMouseEnter = () => {
    setHovered(true);
  };

  const onMouseLeave = () => {
    setHovered(false);
  };

  const color = action.color || 'inherit';
  const backgroundColor = action.backgroundColor || 'inherit';

  return action.action.route ? (
    <Link
      to={action.action.route}
      className="page-action-item"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        color,
        backgroundColor
      }}
    >
      <PageActionIcon
        action={action}
        hovered={hovered}
        solidOnHover={solidIconOnHover}
        solid={solidIcon}
      />
      <span title={action.name} className="page-action-item-name">
        {action.name}
      </span>
    </Link>
  ) : null;
};

export default PageActions;
